import React from "react";
import cn from "classnames";
import Card from "../../components/Card";
import styles from "./Scroll.module.sass";

const Scroll = ({ className, children }) => {
  return <div className={cn(styles.card, className)}>{children}</div>;
};
export default Scroll;
